import React, { useEffect } from 'react';
import { useLocation, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Row } from 'react-bootstrap'

import Header from '../Header';
import Footer from '../Footer';
import { ls } from '../../locale'

const titles = {
  '/extra': ' | Extras',
  '/seats': ' | Seat Selection',
  '/checkout': ' | Check Out',
  '/confirmation': ' | Confirmation',
  '/mmb/summary': ' | Manage My Booking',
};


function LoadingError() {
  return (
    <div>The service is temporarily not available. Please try again later.</div>
  )
}


const PageTitle = ({ title, hasToken, loadingStatus, children }) => {
  const location = useLocation();

  useEffect(() => {
    let key;
    for(key in titles) {
      if (location.pathname.endsWith(key)) {
        document.title = title + titles[key];
        return;
      }
    }
    document.title = title;
  }, [location, title]);

  return hasToken ? <>{children}</> : (
    <div className={ls.t("rootClass") + " main-container search-page"} dir={ls.t("direction")}>
      <div className="header-con">
        <Header />
      </div>
      <div className="container padt80 padb20">
        <Row className="min-height">
          {loadingStatus ? <>Loading...</> : <LoadingError />}
        </Row>
      </div>
      <Footer />
    </div>
  )
};

function mapStateToProps(state) {
  return {
    hasToken: state.session.hasToken,
    loadingStatus: state.redux.loadingStatus
  };
}

export default withRouter(connect(mapStateToProps)(PageTitle));